import { defineMessages } from 'react-intl';

export default defineMessages({
  variantPriceFrom: {
    id: 'components.AnimatedProductCard.variantPriceFrom',
    description: 'Variant Price From Label',
    defaultMessage: 'From',
  },
});
